import React from "react";

//MUI
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import ClientsComboBox from "Components/Client/ClientsComboBox";
import DateWithClear from "Components/UI/Form/DateWithClear";
import { systemStatusOptions } from "utils/options/systemStatusOptions";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import dayjs from "dayjs";

export default function InvoiceFormSystem({
  formData,
  FORM_MODE,
  handleInputChange,
  clients,
}) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled={true}
            name="ParseStatus"
            onChange={(e) => handleInputChange("ParseStatus", e.target.value)}
            label="Kontrollstatus"
            value={formData.ParseStatus}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="text"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled={true}
            name="ParseMessage"
            onChange={(e) => handleInputChange("ParseMessage", e.target.value)}
            label="Kontrollmeddelande"
            value={formData.ParseMessage}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="text"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl margin="dense" fullWidth sx={{ textAlign: "left" }}>
            <InputLabel>System</InputLabel>
            <Select
              disabled={FORM_MODE === "LOCKED" ? true : false}
              name="SystemStatus"
              value={formData.SystemStatus}
              onChange={(e) =>
                handleInputChange("SystemStatus", e.target.value)
              }
              label="Status"
              size="small"
            >
              {systemStatusOptions.map((option) => (
                <MenuItem key={option.Value} value={option.Value}>
                  {option.Name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Skapad"
            label="Skapad"
            value={formData.CreateTime}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ClientsComboBox
            label={"Klient"}
            // disabled={FORM_MODE === "CREATE" ? false : true}
            disabled={FORM_MODE === "LOCKED" ? true : false}
            clients={clients}
            selectedID={formData.ClientId ? formData.ClientId : null}
            onChange={(newVal) => handleInputChange("ClientId", newVal)}
          />
        </Grid>
        <Grid container item xs={12} sm={6} md={4}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: "left",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  disabled={FORM_MODE === "LOCKED"}
                  checked={!!Number(formData.IgnoreWarnings)}
                  onChange={(event) =>
                    handleInputChange(
                      "IgnoreWarnings",
                      event.target.checked ? "1" : "0"
                    )
                  }
                />
              }
              label="Ignorera varningar"
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="BundleNr"
            label="Buntnummer"
            value={formData.BundleId}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            disabled={FORM_MODE === "LOCKED"}
            onChange={(e) => handleInputChange("BundleId", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
            <DateWithClear
              label="Stängd"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              value={dayjs(formData.ClosedDate)}
              onChange={(newVal) => 
                handleInputChange(
                  "ClosedDate",
                  dayjs(newVal).format("YYYY-MM-DD")
                )
              }
            />
          </Grid>
      </Grid>
    </>
  );
}
